export var SEEN_CASES_PURGE_DELAY_MS = 60 * 1000;
